import axios from 'axios'


const bankInfoAxios = axios.create({
    baseURL: 'https://api.corporateportal.plick.eu/corporateservice/bankinfo',
    headers: {
        'content-type': 'application/json',
        'Accept': 'application/json'
    }
})

bankInfoAxios.interceptors.request.use(
    function(config) {
        const token = localStorage.getItem("token");
        if(token) {
            config.headers["Authorization"] = 'Bearer ' + token;
        }
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

export default bankInfoAxios
